import React from 'react';
import Expander from 'components/Expander';

import useDiscounts from 'hooks/useDiscounts';
import { PartnerType } from 'enums/PartnerName';

import styles from './DiscountsExpander.module.scss';

interface DiscountsExpanderProps {
  isOpenByDefault?: boolean;
}

const DiscountsExpander = ({ isOpenByDefault = false }: DiscountsExpanderProps) => {
  const { applicableDiscounts } = useDiscounts();

  const totalDiscountAmount = applicableDiscounts.reduce(
    (acc, discount) => acc + (discount.interestRateDifferencePercent ?? 0),
    0,
  );

  if (totalDiscountAmount === 0) return null;

  const totalDiscount =
    totalDiscountAmount > 0 ? (
      <div className={styles.discountHeader}>
        <p>Total discount</p>
        <span>{totalDiscountAmount.toFixed(2)}%</span>
      </div>
    ) : null;

  const label = (
    <div>
      <b>You're saving {totalDiscountAmount.toFixed(2)}%</b>
      {applicableDiscounts.some((discount) => discount.isPromoDiscount) && (
        <>
          <br />
          <p>Includes limited time promo discount</p>
        </>
      )}
    </div>
  );

  return (
    <Expander
      label={label}
      translateArrow={false}
      isOpenByDefault={isOpenByDefault}
      content={
        <div className={styles.expanderOpen}>
          {totalDiscount}
          <div className={styles.discountSeparator} />
          <div className={styles.discountContainer}>
            {applicableDiscounts.map((discount, index) => (
              <div className={styles.discountRow} key={index}>
                <p>
                  {discount.isTenureDiscount ? 'Tenure' : ''}
                  {discount.isTierDiscount ? discount.credentials : ''}
                  {discount.isPaymentMethodDiscount ? 'Direct Deposit' : ''}
                  {!discount.isTenureDiscount && !discount.isTierDiscount ? discount.discountName : ''}
                  {discount.partnerType === PartnerType.Association && ' Member'}
                  {discount.isPromoDiscount ? discount.promoDiscountText : ' discount'}
                </p>
                <span>{discount.interestRateDifferencePercent.toFixed(2)}%</span>
              </div>
            ))}
          </div>
        </div>
      }
      container={styles.expanderContainer}
      labelClassname={styles.expanderLabel}
      selectArrowClassname={styles.selectArrow}
    />
  );
};

export default DiscountsExpander;
